import { useEffect } from 'react';

/**
 * Runs `check` now, then every `intervalMs` while the tab is visible, and again
 * as soon as the seller comes back to the tab. `check` gets `isCurrent`, false
 * once this poll has stopped, so a late answer can be dropped. Wrap `check` in
 * useCallback: a new function restarts the poll.
 */
export function useVisiblePoll(
  check: (isCurrent: () => boolean) => void | Promise<void>,
  intervalMs: number,
  active: boolean
): void {
  useEffect(() => {
    if (!active) return;
    let current = true;
    const isCurrent = () => current;
    const checkIfVisible = () => {
      if (!document.hidden) void check(isCurrent);
    };
    void check(isCurrent);
    const handle = setInterval(checkIfVisible, intervalMs);
    document.addEventListener('visibilitychange', checkIfVisible);
    return () => {
      current = false;
      clearInterval(handle);
      document.removeEventListener('visibilitychange', checkIfVisible);
    };
  }, [check, intervalMs, active]);
}
